<template>
    <div>
        <template v-if="loading">
            <loading-spinner />
        </template>

        <template v-else>
            <risk-header v-if="showHeader" :risk="risk" :actionsSecondary="headerActionsIsSecondary" />

            <component v-if="pageComponent" :is="pageComponent" :risk="risk" />
        </template>
    </div>
</template>

<script>
    import RiskHeader from '~/components/Shared/Partials/RiskHeader';
    import BrokerSubmissionEntry from './BrokerRisk/BrokerSubmissionEntry';
    import BrokerFirmOrder from './BrokerRisk/BrokerFirmOrder';
    import BrokerFirmOrderSummary from './BrokerRisk/BrokerFirmOrderSummary';
    import BrokerDeclarationSummary from './BrokerRisk/BrokerDeclarationSummary';
    import ManualSubmissionSummary from "./BrokerRisk/ManualSubmissionTracker/ManualSubmissionSummary.vue";

    export default {
        name: 'BrokerRisk',
        components: {
            RiskHeader,
            BrokerSubmissionEntry,
            BrokerFirmOrder,
            BrokerFirmOrderSummary,
            BrokerDeclarationSummary,
            ManualSubmissionSummary
        },
        data() {
            return {
                loading: true,
                risk: false
            }
        },
        computed: {
            pageComponent() {
                if (this.risk) {
                    if (this.riskType === 'manual_submission') {
                        return 'manual-submission-summary'
                    }
                    switch (this.risk.status) {
                        case 'draft':
                            return 'broker-submission-entry';
                        case 'in_the_market':
                        case 'declined':
                        case 'closed':
                            return 'broker-firm-order';
                        case 'firm_ordered':
                            return 'broker-firm-order-summary';
                        case 'bound':
                        case 'expired':
                        case 'off_risk':
                            return 'broker-declaration-summary';
                        default:
                            // no status matched
                    }
                }
            },
            headerActionsIsSecondary() {
                if (this.risk.status === 'in_the_market') {
                    return true;
                }

                return false;
            },
            showHeader() {
                if (this.riskType === 'manual_submission') {
                    return true;
                }

                if (this.risk && this.risk.status === 'draft') {
                    return false;
                }

                return true;
            },
            riskType() {
                switch (this.$route.name) {
                    case 'manual-submission-risk': return 'manual_submission';
                    default: return 'submission';
                }
            }
        },
        mounted() {
            this.loadRisk(this.$route.params.id);

            this.$eventBus.$on('submissionChanged', () => {
                this.loadRisk(this.$route.params.id);
            });
        },
        beforeRouteUpdate(to, from, next) {
            this.loadRisk(to.params.id);
            next();
        },
        methods: {
            async loadRisk(riskId) {
                this.loading = true;

                if (this.riskType === 'manual_submission') {
                    this.risk = (await axios.get(this.$root.api(`broker/manual-submission-tracker/${riskId}`))).data.data;
                } else {
                    this.risk = riskId === 'new' ? { status: 'draft' } : (await axios.get(this.$root.api(`broker/risk/${riskId}`))).data.data;
                }

                this.loading = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    header {
        animation: fade-in 1s;
    }
</style>
